import { StatusComponent } from '../all-screenings/component/StatusComponent';
import nudgeAngelDispatcher from './action';
import GroupToolbar from './component/GroupToolbar';
import ModalAddOrEditAngelNudge from './component/ModalAddOrEditAngelNudge';
import {
  ANGEL_NUDGE,
  ANGEL_NUDGE_FALLBACK,
  ANGEL_NUDGE_STATUS,
  ANGEL_NUDGE_STATUS_COLORS,
  COLUMN_ANGEL_NUDGE,
  NUDGE_STATUS,
  NUDGE_STATUS_COLORS,
  NUDGE_STATUS_OPTIONS,
  TYPE_MODAL,
} from './constants';
import {
  CloseCircle,
  CreateNewIcon,
  EditIcon,
  NoDataQueueClosureIcon,
  ShieldCheckmarkIcon,
  DeactivateIcon,
  ActivateIcon,
  DeleteModalIcon,
  BanIcon,
} from '@/assets/svg';
import { handleSelectAll } from '@/helpers';
import CustomMenu from '@/new-components/CustomMenu';
import CustomMenuActions from '@/new-components/CustomMenuActions';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import { Button, Drawer, IconButton } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { MoreVertRounded } from '@material-ui/icons';
import { debounce, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const AngelNudgeManagement = () => {
  const { list: data, paging } = useSelector((state) => state.nudgeAngel);
  const [filterOption, setFilterOption] = useState({});
  const [sortOption, setSortOption] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  const [searchKey, setSearchKey] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [typeModal, setTypeModal] = useState(null);
  const [angelNudgeStatuses, setAngelNudgeStatuses] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [eventTriggers, setEventTriggers] = useState([]);
  const [nudgeStatuses, setNudgeStatuses] = useState([]);

  const onResetFilterOps = () => {
    setAngelNudgeStatuses([]);
    setFilterOption({});
    setNudgeStatuses([]);
  };

  const onShowModal = (type) => {
    setShowModal(true);
    setTypeModal(type);
  };

  const onCloseModal = () => {
    setShowModal(false);
    setTypeModal(null);
  };

  const onFilterOptionChange = (key) => (e, newValue) => {
    let value = e.target.value;

    switch (key) {
      case 'statuses':
        value = handleSelectAll(
          value,
          ANGEL_NUDGE_STATUS.map((item) => item.key),
          angelNudgeStatuses
        );
        setAngelNudgeStatuses(value);
        break;

      case 'nudgeStatus':
        let isActive;
        value = handleSelectAll(
          value,
          NUDGE_STATUS_OPTIONS.map((item) => item.key),
          nudgeStatuses
        );

        if (
          value.length === 0 ||
          value.length === NUDGE_STATUS_OPTIONS.length
        ) {
          isActive = undefined;
        } else if (value.includes(NUDGE_STATUS.Active)) {
          isActive = true;
        } else if (value.includes(NUDGE_STATUS.InActive)) {
          isActive = false;
        }

        setNudgeStatuses(value);
        setFilterOption({
          ...filterOption,
          isActive,
        });
        return;
      default:
        break;
    }

    setFilterOption({
      ...filterOption,
      [key]: value,
    });
  };
  const onDeleteNudge = () => {
    if (isEmpty(selectedItem)) return;
    setLoading(true);

    nudgeAngelDispatcher.deleteNudgeAngel(
      selectedItem.id,
      () => {
        customToast('success', 'Nudge has been deleted successfully.', 'Nudge');
        fetchData(searchKey, paging, sortOption, filterOption);
        setShowDeleteModal(false);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const onActivateNudge = () => {
    const activeStatus = selectedItem.isActive;
    setLoading(true);
    nudgeAngelDispatcher.updateNudgeAngelStatus(
      selectedItem.id,
      !activeStatus,
      () => {
        fetchData(searchKey, paging, filterOption);
        setShowActiveModal(false);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const handleUpdateNudge = (type, data) => {
    setLoading(true);
    switch (type) {
      case TYPE_MODAL.Edit:
        nudgeAngelDispatcher.editNudgeAngel(
          selectedItem.id,
          data,
          () => {
            fetchData(searchKey, paging, sortOption, filterOption);
            customToast(
              'success',
              'Nudge has been updated successfully.',
              'Nudge'
            );
            onCloseModal();
            setLoading(false);
          },
          () => {
            setLoading(false);
          }
        );

        break;
      case TYPE_MODAL.Create:
        nudgeAngelDispatcher.createNudgeAngel(
          data,
          () => {
            fetchData(searchKey, paging, sortOption, filterOption);
            customToast(
              'success',
              'Nudge has been created successfully.',
              'Nudge'
            );
            onCloseModal();
            setLoading(false);
          },
          () => {
            setLoading(false);
          }
        );

        break;
      default:
        break;
    }
  };

  const fetchData = async (
    search = searchKey,
    pagingData = paging,
    sortOptionData = sortOption,
    filterOptionData = filterOption
  ) => {
    nudgeAngelDispatcher.getData(
      search,
      pagingData,
      sortOptionData,
      filterOptionData
    );
  };

  const debounceLoadData = useCallback(
    debounce((searchKey, paging, sortOption, filterOption) => {
      fetchData(
        searchKey,
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        sortOption,
        filterOption
      );
    }, 500),
    []
  );

  useEffect(() => {
    debounceLoadData(searchKey, paging, sortOption, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, sortOption, filterOption]);

  useEffect(() => {
    nudgeAngelDispatcher.getEventTriggers((res) => {
      setEventTriggers(res);
    });
    return () => {
      nudgeAngelDispatcher.resetData();
    };
  }, []);

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_ANGEL_NUDGE.map((item) => (
          <TableCell
            key={item.stateValue || item.label}
            style={{ minWidth: item.minWidth, width: item.width }}
          >
            {item.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row) => {
    return (
      <>
        <TableCell>
          {row?.nudgeType === 'Rules' ? 'Rules (SQL)' : row?.nudgeType || '—'}
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.name || '—'} />
        </TableCell>
        <TableCell align="center">
          {row.nudgeType === 'Rules'
            ? row.triggerTime
            : eventTriggers.find((it) => it.eventTrigger === row.eventTrigger)
                ?.name}
        </TableCell>
        <TableCell align="center">{row?.totalFollowUpEvent || '—'}</TableCell>
        <TableCell>
          <StatusComponent
            filterList={ANGEL_NUDGE}
            filterListColor={ANGEL_NUDGE_STATUS_COLORS}
            status={row.status}
          />
        </TableCell>
        <TableCell>
          <StatusComponent
            filterList={ANGEL_NUDGE_FALLBACK}
            filterListColor={ANGEL_NUDGE_STATUS_COLORS}
            status={row.fallbackAction}
          />
        </TableCell>
        <TableCell>
          <StatusComponent
            filterList={NUDGE_STATUS}
            filterListColor={NUDGE_STATUS_COLORS}
            status={row.isActive ? 'Active' : 'Inactive'}
          />
        </TableCell>

        <TableCell>
          <IconButton
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setSelectedItem(row);
            }}
          >
            <MoreVertRounded />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const renderListActions = (selectedItem) => {
    if (!selectedItem) return [];

    let listActions = [
      {
        key: 'edit',
        icon: EditIcon,
        label: 'Edit Parent Nudge',
        styles: { width: 20, height: 20 },
        onClick: () => {
          setAnchorEl(null);
          onShowModal(TYPE_MODAL.Edit);
        },
      },
      {
        key: `mark-as-${selectedItem.isActive ? 'inactive' : 'active'}`,
        icon: selectedItem.isActive ? BanIcon : ShieldCheckmarkIcon,
        label: selectedItem.isActive
          ? 'Deactivate Parent Nudge'
          : 'Activate Parent Nudge',
        color: selectedItem.isActive ? '#DB3D49' : '#0B8E5E',
        styles: { width: 18, height: 18 },
        onClick: () => {
          setAnchorEl(null);
          setShowActiveModal(true);
        },
      },
      {
        key: 'cancel',
        icon: CloseCircle,
        label: 'Delete Parent Nudge',
        color: '#DB3D49',
        styles: { width: 18, height: 18 },
        onClick: () => {
          setAnchorEl(null);
          setShowDeleteModal(true);
        },
      },
    ];

    return listActions;
  };

  return (
    <>
      <CustomMenu
        id="simple-menu"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <CustomMenuActions listActions={renderListActions(selectedItem)} />
      </CustomMenu>
      <CustomPaperContainer
        header={
          <CustomHeader
            title="Angel Nudge Management"
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            searchPlaceholder="Search by name ..."
            setSearchKey={setSearchKey}
            searchKey={searchKey}
            fetchData={fetchData}
            renderToolbar={() => (
              <GroupToolbar
                filterOption={filterOption}
                setFilterOption={setFilterOption}
                onFilterOptionChange={onFilterOptionChange}
                onResetFilterOps={onResetFilterOps}
                angelNudgeStatuses={angelNudgeStatuses}
                nudgeStatuses={nudgeStatuses}
              />
            )}
            renderButton={() => (
              <Button
                color="primary"
                variant="contained"
                startIcon={<CreateNewIcon />}
                onClick={() => {
                  setSelectedItem(null);
                  onShowModal(TYPE_MODAL.Create);
                }}
              >
                Create new
              </Button>
            )}
          />
        }
      >
        <CustomTable
          data={data}
          paging={paging}
          header={TableHeader}
          renderRow={(row, i) => renderTableBody(row)}
          noDataHelperText="No nudge"
          noDataHelperSubText="Please create a new nudge"
          totalCols={COLUMN_ANGEL_NUDGE.length}
          fetchData={fetchData}
          Icon={NoDataQueueClosureIcon}
        />
      </CustomPaperContainer>

      <Drawer
        anchor="right"
        open={showModal}
        onClose={onCloseModal}
        disableBackdropClick
        PaperProps={{
          style: {
            width: '80%',
            minWidth: 720,
          },
        }}
      >
        <ModalAddOrEditAngelNudge
          loading={loading}
          onSubmit={handleUpdateNudge}
          selectedItem={selectedItem}
          typeModal={typeModal}
          eventTriggers={eventTriggers}
          onClose={() => {
            setShowModal(false);
            fetchData();
          }}
        />
      </Drawer>
      {showDeleteModal && (
        <ModalConfirmation
          open={showDeleteModal}
          onClick={onDeleteNudge}
          onClose={() => setShowDeleteModal(false)}
          mainContent="Delete Parent Nudge"
          subContent="Are you sure you want to delete this Parent Nudge?"
          cancelLabel="Cancel"
          confirmLabel="Delete"
          confirmColor="red"
          Icon={<DeleteModalIcon />}
        />
      )}

      {showActiveModal && (
        <ModalConfirmation
          loading={loading}
          open={showActiveModal}
          onClick={onActivateNudge}
          onClose={() => setShowActiveModal(false)}
          mainContent={`${
            selectedItem.isActive ? 'Deactivate' : 'Activate'
          } Parent Nudge`}
          subContent={`Are you sure you want to ${
            selectedItem.isActive ? 'deactivate' : 'activate'
          } this Parent Nudge?`}
          cancelLabel="Cancel"
          confirmLabel={selectedItem.isActive ? 'Deactivate' : 'Activate'}
          Icon={selectedItem.isActive ? <DeactivateIcon /> : <ActivateIcon />}
        />
      )}
    </>
  );
};

export default AngelNudgeManagement;
